if (!customElements.get('feature-highlight')) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class FeatureHighlight extends HTMLElement {
    connectedCallback() {
      this.onMotionPreferenceChange = this.onMotionPreferenceChange.bind(this);
      reduceMotion.addEventListener('change', this.onMotionPreferenceChange);
      this.onMotionPreferenceChange();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      reduceMotion.removeEventListener('change', this.onMotionPreferenceChange);
    }

    onMotionPreferenceChange() {
      if (reduceMotion.matches) {
        if (this.observer) this.observer.disconnect();
        this.classList.add('is-visible');
        return;
      }

      if (this.observer) return;

      const trigger = this.querySelector('.feature-highlight__trigger');

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this));
        this.observer.observe(trigger);
      } else {
        this.classList.add('is-visible');
      }
    }

    onIntersect(entries) {
      entries.forEach((entry) => {
        this.classList.toggle('is-visible', entry.isIntersecting);
      });
    }
  }

  customElements.define('feature-highlight', FeatureHighlight);
}
